import React, { useEffect, useState } from 'react';
import HeaderWithIcon from '../components/common/HeaderWithIcon';
import { Pagination } from 'flowbite-react';
import payApi from '../api/pay';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

export default function PaymentTransactions() {
  const { tokens } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 50;

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await payApi.getPaymentTransactions(tokens.access.token, page, limit);
        if (response.status === 200 && response.data.success) {
          setTransactions(response.data.transactions.rows);
          setTotalPages(Math.ceil(response.data.transactions.count / limit));
        } else {
          setError('Failed to fetch payment transactions');
        }
      } catch (err) {
        setError('Error fetching payment transactions');
      } finally {
        setLoading(false);
      }
    };
    if (tokens?.access?.token) {
      fetchTransactions();
    }
  }, [tokens, page]);

  return (
    <div className='min-h-screen relative overflow-hidden'>
      <HeaderWithIcon title='Payment Transactions' />
      <div className='px-5 pt-4'>
        {loading ? (
          <div className='py-4 text-center text-gray-500'>Loading...</div>
        ) : error ? (
          <div className='py-4 text-center text-red-500'>{error}</div>
        ) : transactions.length === 0 ? (
          <div className='py-4 text-center text-gray-500'>No payment transactions found.</div>
        ) : (
          <div className='overflow-x-auto'>
            <table className='min-w-full bg-white border rounded-md'>
              <thead>
                <tr className='bg-gray-100 text-xs'>
                  <th className='p-2 border'>Request ID</th>
                  <th className='p-2 border'>Amount</th>
                  <th className='p-2 border'>Currency</th>
                  <th className='p-2 border'>Status</th>
                  <th className='p-2 border'>Created At</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx) => (
                  <tr key={tx.id} className='text-xs text-center'>
                    <td className='p-2 border whitespace-nowrap'>
                      {tx.paymentRequestId ? (
                        <Link
                          to={`/payment-request/${tx.paymentRequestId}`}
                          className='text-blue-600 underline hover:text-blue-800 break-all'
                        >
                          {tx.paymentRequestId}
                        </Link>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td className='p-2 border whitespace-nowrap'>{tx.amount}</td>
                    <td className='p-2 border whitespace-nowrap'>{tx.currency}</td>
                    <td className='p-2 border whitespace-nowrap'>{tx.status}</td>
                    <td className='p-2 border whitespace-nowrap'>{tx.createdAt ? new Date(tx.createdAt).toLocaleString() : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {totalPages > 1 && (
          <div className='flex justify-center my-4'>
            <Pagination
              currentPage={page}
              totalPages={totalPages}
              onPageChange={setPage}
            />
          </div>
        )}
      </div>
    </div>
  );
} 